import React from "react";

export default function ContactForm() {
  return (
    <form className="rounded-3xl bg-slate-100 p-5 space-y-4">
      <input className="w-full p-4 rounded-2xl outline-none border border-slate-200 text-slate-900" placeholder="Your Name" />
      <input className="w-full p-4 rounded-2xl outline-none border border-slate-200 text-slate-900" placeholder="Mobile Number" />
      <input className="w-full p-4 rounded-2xl outline-none border border-slate-200 text-slate-900" placeholder="Email Address" />
      <textarea className="w-full p-4 rounded-2xl outline-none border border-slate-200 h-28 text-slate-900" placeholder="Tell us about your project" />
      <button type="button" className="w-full py-4 rounded-2xl bg-gradient-to-r from-pink-500 to-violet-700 text-white font-black">
        Send Message
      </button>
    </form>
  );
}
